<ng-container *ngIf="monitors && monitors.length; else emptyMonitorsList">
  <div class="full-screen-container h-100" #selectContainer>
    <div class="selected-full-screen text-center">
      <ng-container *ngIf="monitorChangeViewService?.fullScreenMonitor; else notSelectedFullScreen">
        <monitor [viewMode]="viewMode" [monitor]="monitorChangeViewService?.fullScreenMonitor" [clickOutside]="[]"
          [parentComponent]="selectContainer">
        </monitor>
      </ng-container>

      <ng-template #notSelectedFullScreen>
        <p class="m-0 py-3">You have not chosen a monitor to display it in full-screen mode yet.</p>
      </ng-template>

      <div class="full-screen-carousel">
        <swiper [config]="swiperConfig">
          <monitor *ngFor="let monitor of getListOfMonitorsToSelect()" [monitor]="monitor" [isSelectionEnable]="false">
          </monitor>
        </swiper>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #emptyMonitorsList>
  <div class="h-100 d-flex align-items-center justify-content-center flex-column">
    <p class="m-0">The monitor`s list is empty.</p>
    <p class="m-0">Connect at least one monitor to see it here or change your filter options.</p>
  </div>
</ng-template>